
import { defineComponent } from "vue";

export default defineComponent({
  name: "category-item",
  props: {
    icon: String,
    title: String,
    backgroundColor: String,
    isSelected: Boolean,
  },
});
